import React, { useState } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';
import { store } from '../../Store'
import { useLocation, useNavigate } from 'react-router'
import { withRouter, Outlet } from 'react-router-dom';

import withErrorHandler from '../../hocs/withErrorHandler'
import axios from '../../httpClients/axios-datamerch'
import * as actions from '../../store/actions'

import { Sidebar, Topbar, Footer } from './components';

import { MerchantNotFoundDialog } from '../../components/Merchant';
import { Timeout } from '../../components';
import { FeedbackWidget, FeedbackDialog } from '../../components/Feedback';
import useClasses from '../../helpers/useClasses';
import { history } from '../../history';
import Maintenance from '../../components/UI/Maintenance'


const styles = theme => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64
    }
  },
  shiftContent: {
    paddingLeft: 240
  },
  content: {
    height: '100%'
  }
});

const DMAdmin = React.memo(props => {
  const user = store.getState().auth
  // const location = window.location;
  const location = history.location;
  if (!user.isLoggedIn || !user.user.is_dm_admin) {
    store.dispatch({
      type: 'UNAUTHORIZED',
      from: location.pathname
    })
  }
  
  let navigate = useNavigate()

  const { token, account } = props;

  const classes = useClasses(styles);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true
  });

  const [openSidebar, setOpenSidebar] = useState(false);
  
  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const merchantSearch = (search, token, user) => {
    return { type: 'SEARCH_MERCHANTS', search: search, token: token, user: user }
  };

  const handleMerchantSearchClick = (event, search) => {
    event.preventDefault();
    store.dispatch(merchantSearch(search, token, user))

    navigate("/search")
  }

  const logoutUser = () => {
    return { type: 'LOGOUT_USER' }
  };

  const handleLogoutClick = () => {
    store.dispatch(logoutUser())
  }

  const shouldOpenSidebar = isDesktop ? true : openSidebar;

  let main = (
    <div
      className={clsx({
        [classes.root]: true,
        [classes.shiftContent]: isDesktop
      })}
    >
      <Maintenance /> 
      <Timeout />
      <Topbar 
        onSidebarOpen={handleSidebarOpen}
        onMerchantSearchClick={(event, search) => handleMerchantSearchClick(event, search)} 
        onLogoutClick={handleLogoutClick}
        user={user}
      />
      <Sidebar
        onClose={handleSidebarClose}
        open={shouldOpenSidebar}
        variant={isDesktop ? 'persistent' : 'temporary'}
        onMerchantSearchClick={(event, search) => handleMerchantSearchClick(event, search)}
        onLogoutClick={handleLogoutClick}
      />
      <main className={classes.content}>
        <Outlet />
        <Footer />
        <FeedbackWidget />
        <FeedbackDialog />
      </main>
    </div>
  )

  // if (searched){
  //   main = (
  //     <Redirect to="/search" />
  //   )
  // }

  return (
    <React.Fragment>
      {main}
      <MerchantNotFoundDialog />
    </React.Fragment>
  );
});

DMAdmin.propTypes = {
  children: PropTypes.node
};

const mapStateToProps = state => {
  return {
    //account: state.auth.user.account,
    // saving: state.account.saving,
    user: state.auth.user,
    token: state.auth.token,
    openAddMerchantDialog: state.merchant.openAddMerchantDialog
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onMerchantSearch: (token, search, user) => dispatch(actions.searchMerchants(token, search, user)),
    onMerchantSearchReset: (token) => dispatch(actions.searchMerchantsReset(token)),
    onLogoutClick: () => dispatch(actions.logout())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DMAdmin)
